import { create } from "zustand";

type ThemeMode = "dark" | "light" | "system";

interface UiState {
  readonly agentPanelVisible: boolean;
  readonly statusBarVisible: boolean;
  readonly backendReady: boolean;
  readonly pendingAgentQuery: string | null;
  readonly pendingAgentMentionIds: readonly string[];
  readonly theme: ThemeMode;
  toggleAgentPanel: () => void;
  toggleStatusBar: () => void;
  setBackendReady: (ready: boolean) => void;
  setPendingAgentQuery: (query: string | null) => void;
  setPendingAgentMentionIds: (ids: readonly string[]) => void;
  setTheme: (theme: ThemeMode) => void;
}

function readStoredTheme(): ThemeMode {
  const stored = localStorage.getItem("magnis-theme");
  if (stored === "dark" || stored === "light" || stored === "system") return stored;
  return "dark";
}

export const useUiStore = create<UiState>((set) => ({
  agentPanelVisible: true,
  statusBarVisible: true,
  backendReady: false,
  pendingAgentQuery: null,
  pendingAgentMentionIds: [],
  theme: readStoredTheme(),
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  toggleAgentPanel: () => { set((s) => ({ agentPanelVisible: !s.agentPanelVisible })); },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  toggleStatusBar: () => { set((s) => ({ statusBarVisible: !s.statusBarVisible })); },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setBackendReady: (ready) => { set({ backendReady: ready }); },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setPendingAgentQuery: (query) => { set({ pendingAgentQuery: query }); },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setPendingAgentMentionIds: (ids) => { set({ pendingAgentMentionIds: ids }); },
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setTheme: (theme) => {
    localStorage.setItem("magnis-theme", theme);
    set({ theme });
  },
}));
